import { Multimedia } from '@web/shared/module/multimedia';
import { AdminBrandBannerStatus } from '@web/shared/module/brand';
import { Guid, Nillable } from '@web/utils';

export class AdminBrandBannerDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      file: Multimedia;
      id: Guid;
      redirects: number;
      smallFile?: Nillable<Multimedia>;
      status: AdminBrandBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get smallFile(): Nillable<Multimedia> {
    return this.data.smallFile;
  }

  public get status(): AdminBrandBannerStatus {
    return this.data.status;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }

  public get redirects(): number {
    return this.data.redirects;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }
}
